import React from 'react';
import PropTypes from 'prop-types';

import IntegrationActionLink from './IntegrationActionLink';
import { Spinner } from '@companycam/slab-web';
import { translate } from 'translations/i18n';

const IntegrationActionLinks = ({
  integrationActions,
  isIntegrationActionsLoading,
  projectNodeId,
  projectDatabaseId,
  requestArgs,
}) => {
  if (isIntegrationActionsLoading) {
    return (
      <Spinner
        accessibilityLabel={translate('common.loading')}
        ccMargin="xs none xs m"
        size="xsmall"
      />
    );
  }

  if (!integrationActions.length) {
    return null;
  }

  return (
    <>
      {integrationActions.map((integrationAction) => {
        return (
          <IntegrationActionLink
            key={integrationAction.id}
            integrationAction={integrationAction}
            projectNodeId={projectNodeId}
            projectDatabaseId={projectDatabaseId}
            requestArgs={requestArgs}
          />
        );
      })}
    </>
  );
};

IntegrationActionLinks.propTypes = {
  integrationActions: PropTypes.array.isRequired,
  projectNodeId: PropTypes.string.isRequired,
  requestArgs: PropTypes.shape({
    photo_ids: PropTypes.arrayOf(PropTypes.number),
  }),
  isIntegrationActionsLoading: PropTypes.bool.isRequired,
  projectDatabaseId: PropTypes.number,
};

export default IntegrationActionLinks;
